import {createSlice,	PayloadAction}		from '@reduxjs/toolkit';

import {UploadDocument, UploadPercentState,
	DocumentState}							from './interface';

const initialState: DocumentState = {
	uploadDocument: []
};

export const Reducer = createSlice({
	name:     'documents',
	initialState,
	reducers: {
		pushUpload: (state, action: PayloadAction<UploadDocument>) => {
			action.payload.isClose = false;
			state.uploadDocument.push(action.payload);
		},
		setUploadPercent: (state, action: PayloadAction<UploadPercentState>) => {
			if (state.uploadDocument[action.payload.index])
				state.uploadDocument[action.payload.index].percent = action.payload.percent;
		},
		closeUpload: (state, action: PayloadAction<number>) => {
			if (state.uploadDocument[action.payload])
				state.uploadDocument[action.payload].isClose = true;
		},
		hideNotification: (state, action: PayloadAction<number>) => {
			if (state.uploadDocument[action.payload])
				state.uploadDocument[action.payload].hideNotification = true;
		}
	}
});

export const {pushUpload, setUploadPercent, closeUpload, hideNotification} = Reducer.actions;

export default Reducer.reducer;
